// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m51DCYKXX0ot0tmHGQfP,.m51DCYKXX0ot0tmHGQfP:before{color:var(--redDark)!important}.m51DCYKXX0ot0tmHGQfP:hover:before{color:#e81123}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagIcon": "m51DCYKXX0ot0tmHGQfP"
};
module.exports = ___CSS_LOADER_EXPORT___;
